import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { ChildrenProductAttribute, ProductAttribute } from "../types";

export const useAttributeMatch = (
  flattenedProductAttributes: (ProductAttribute | ChildrenProductAttribute)[]
) => {
  const { attributeId: idFromPath } = useParams<{ attributeId?: string }>();
  const matchedProductAttribute = useMemo(() => {
    return flattenedProductAttributes.find(
      (attribute) => attribute.id === Number.parseInt(idFromPath || "0")
    );
  }, [flattenedProductAttributes, idFromPath]);
  return { matchedProductAttribute };
};
